import React, { useEffect } from 'react';
import { ReturnIcon } from '../icons';
import { CollapsedResultContentWrapper, CollapsedResultDetail, CollapsedResultDetailWrapper, DetailsSeparator, IconContainer, ResultContentWrapper, ResultDetail, ResultLabel, ResultTitleContainer, ReturnIconContainer } from './search-result.styled';
export var HIGHLIGHT_START_TAG = '@@@hl@@@';
export var HIGHLIGHT_END_TAG = '@@@endhl@@@';
var getResultLabel = function getResultLabel(label) {
  if (typeof label === 'string') {
    return /*#__PURE__*/React.createElement(ResultLabel, {
      title: typeof label === 'string' ? label : undefined
    }, label);
  }
  return label;
};
var getResultTitle = function getResultTitle(title) {
  if (typeof title === 'string') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      title: title,
      className: "SearchDialogResultTitle"
    }, title));
  }
  return title;
};

/**
 * This component is intended to be used as a default for display search result
 * content. It is highly recommended for this component to be wrapped in a
 * SearchResultLink.
 *
 * Since this component is being used to render different entity types,
 * e.g. Search Results, but also Recent Searchers, we should consider
 * renaming to it something more generic at some stage, like SearchDialogItem.
 * Note: renaming it will require a major update since it changes the API.
 */
export var SearchResultContent = function SearchResultContent(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    title = _ref.title,
    meta = _ref.meta,
    additionalMeta = _ref.additionalMeta,
    isCollapsed = _ref.isCollapsed,
    isKeyboardHighlighted = _ref.isKeyboardHighlighted;
  var getResultContent = function getResultContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isCollapsed ? /*#__PURE__*/React.createElement(CollapsedResultContentWrapper, {
      "data-testid": "collapsed-result-view"
    }, /*#__PURE__*/React.createElement(ResultTitleContainer, {
      isCollapsed: true
    }, getResultLabel(label), getResultTitle(title)), /*#__PURE__*/React.createElement(CollapsedResultDetailWrapper, null, meta && /*#__PURE__*/React.createElement(CollapsedResultDetail, {
      title: typeof meta === 'string' ? meta : undefined
    }, meta), additionalMeta && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DetailsSeparator, null, '•'), /*#__PURE__*/React.createElement(CollapsedResultDetail, null, additionalMeta)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResultTitleContainer, null, getResultLabel(label), getResultTitle(title)), meta && /*#__PURE__*/React.createElement(ResultDetail, {
      title: typeof meta === 'string' ? meta : undefined
    }, meta), additionalMeta ? /*#__PURE__*/React.createElement(ResultDetail, {
      title: typeof additionalMeta === 'string' ? additionalMeta : undefined
    }, additionalMeta) : null));
  };
  var contentRef = React.useRef(null);
  useEffect(function () {
    var _contentRef$current;
    if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) {
      contentRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'nearest'
      });
    }
  }, [isKeyboardHighlighted]);
  return /*#__PURE__*/React.createElement(ResultContentWrapper, {
    ref: contentRef,
    isCollapsed: isCollapsed,
    isKeyboardHighlighted: isKeyboardHighlighted
  }, /*#__PURE__*/React.createElement(IconContainer, null, icon), getResultContent(), /*#__PURE__*/React.createElement(ReturnIconContainer, {
    isCollapsed: isCollapsed,
    isKeyboardHighlighted: isKeyboardHighlighted
  }, /*#__PURE__*/React.createElement(ReturnIcon, {
    inverted: true
  })));
};